export default "__VITE_ASSET__DIgdR6Hr__"